// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .DocumentList-listPhotoCover-dtEiH {
 	display: block;
 	height: 150px;
 	-webkit-backface-visibility: hidden;
 	        backface-visibility: hidden;
 	position: relative;
 	vertical-align: bottom;
 	overflow: hidden;
 	background-color: var(--common-gray-bg-color);
 	text-align: center;
 	margin-top: 24px;
 }

 .DocumentList-listPhotoMedia-EhOfX {
 	position: absolute;
 	right: 0;
 	left: 0;
 	bottom: 0;
 	top: 0;
 	padding: 5px;
 }

 .DocumentList-imgResponsive-GDczD {
 	height: 100%;
 	width: auto;
 	max-width: 100%;
 	-o-object-fit: contain;
 	   object-fit: contain;
 }

 .DocumentList-space2-TvfIA {
 	margin-bottom: 12px;
 }

 .DocumentList-realtive-Dvmao {
 	position: relative;
 }

 .DocumentList-position-rFSMf {
 	position: absolute;
 	top: 6px;
 	right: 6px;
 	width: 26px;
 	height: 26px;
 	background: #424856;
 	border-radius: 50%;
 	display: -webkit-box;
 	display: -ms-flexbox;
 	display: flex;
 	-webkit-box-pack: center;
 	    -ms-flex-pack: center;
 	        justify-content: center;
 	-webkit-box-align: center;
 	    -ms-flex-align: center;
 	        align-items: center;
 	padding-left: 1px;
 	-webkit-filter: drop-shadow(0 2px 2px rgba(0, 0, 0, .2));
 	        filter: drop-shadow(0 2px 2px rgba(0, 0, 0, .2));
 }`, "",{"version":3,"sources":["webpack://./src/components/DocumentList/DocumentList.css"],"names":[],"mappings":"CAAC;EACC,cAAc;EACd,aAAa;EACb,mCAA2B;UAA3B,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,SAAS;EACT,MAAM;EACN,YAAY;CACb;;CAEA;EACC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAmB;KAAnB,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,iBAAiB;EACjB,wDAAgD;UAAhD,gDAAgD;CACjD","sourcesContent":[" .listPhotoCover {\n \tdisplay: block;\n \theight: 150px;\n \tbackface-visibility: hidden;\n \tposition: relative;\n \tvertical-align: bottom;\n \toverflow: hidden;\n \tbackground-color: var(--common-gray-bg-color);\n \ttext-align: center;\n \tmargin-top: 24px;\n }\n\n .listPhotoMedia {\n \tposition: absolute;\n \tright: 0;\n \tleft: 0;\n \tbottom: 0;\n \ttop: 0;\n \tpadding: 5px;\n }\n\n .imgResponsive {\n \theight: 100%;\n \twidth: auto;\n \tmax-width: 100%;\n \tobject-fit: contain;\n }\n\n .space2 {\n \tmargin-bottom: 12px;\n }\n\n .realtive {\n \tposition: relative;\n }\n\n .position {\n \tposition: absolute;\n \ttop: 6px;\n \tright: 6px;\n \twidth: 26px;\n \theight: 26px;\n \tbackground: #424856;\n \tborder-radius: 50%;\n \tdisplay: flex;\n \tjustify-content: center;\n \talign-items: center;\n \tpadding-left: 1px;\n \tfilter: drop-shadow(0 2px 2px rgba(0, 0, 0, .2));\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listPhotoCover": `DocumentList-listPhotoCover-dtEiH`,
	"listPhotoMedia": `DocumentList-listPhotoMedia-EhOfX`,
	"imgResponsive": `DocumentList-imgResponsive-GDczD`,
	"space2": `DocumentList-space2-TvfIA`,
	"realtive": `DocumentList-realtive-Dvmao`,
	"position": `DocumentList-position-rFSMf`
};
module.exports = ___CSS_LOADER_EXPORT___;
